import { render, staticRenderFns } from "./lamsAuthRegApproval.vue?vue&type=template&id=9091c9c0&scoped=true&"
import script from "./lamsAuthRegApproval.vue?vue&type=script&lang=js&"
export * from "./lamsAuthRegApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9091c9c0",
  null
  
)

export default component.exports